export default __webpack_public_path__ + "static/media/gilroy-regular-3-webfont.0df18679.woff2";